<div class="am-keyboard fs-26px {{ isFloat? 'am-keyboard-position z-index-100' : '' }}"
  [ngClass]="{'bg-light-extra': !isDarkTheme, 'bg-am-darkblue':isDarkTheme}">
  <div class="am-keyboard-navigation border-am-bottom" *ngIf="showNavigateBar">
    <button class="am-navigate-button my-4 mx-4 d-flex align-items-center" (click)="onPrev()">
      <i class="fas fa-angle-left fa-2x"></i>
      <span class="ml-4">{{ 'key.prev_field' | translate }}</span>
    </button>
    <button class="am-navigate-button my-4 mx-4 d-flex align-items-center" (click)="onNext()">
      <span class="mr-4">{{'key.next_field' | translate}}</span>
      <i class="fas fa-angle-right fa-2x"></i>
    </button>
  </div>
  <div class="d-flex flex-column justify-content-center align-items-center w-100 txt-Garnett-Semibold"
    *ngIf="!nameList && keyBoard?.length > 0">
    <div class="am-keyboard-numeric" *ngFor="let row of keyBoard">
      <div *ngFor="let key of row">
        <app-am-key [key]="key" [type]="type" [reference]=inputReference [currentFormCtr]="currentFormCtr"
          [isDarkTheme]="isDarkTheme" *ngIf="inputReference">
        </app-am-key>
      </div>
    </div>
  </div>
  <div class="keyboard-select d-flex flex-column justify-content-center align-items-center w-100" *ngIf="nameList">
    <div class="d-flex justify-content-end w-75 px-5 py-0">
      <app-am-key [key]="hideKey" [type]="'text'" [reference]=inputReference [currentFormCtr]="currentFormCtr"
        [isDarkTheme]="isDarkTheme" *ngIf="inputReference">
      </app-am-key>
    </div>
    <app-am-scroll [height]="294">  
      <ul class="am-select" [ngClass]="{ 'keyboard-ajustText': nameList == 'answersHavana' }">
          <li *ngFor="let item of optionsList; let i = index" (click)="onSelectItem( item, i )"
            [ngClass]="{ 'selected': item.selected }">
            {{ item.description }}
          </li>
      </ul>
    </app-am-scroll>
  </div>
</div>
